// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IHeader } from './IHeader';
import {
    IHeaderFromJSON,
    IHeaderFromJSONTyped,
    IHeaderToJSON,
    IHeaderToJSONTyped,
} from './IHeader';

/**
 * 
 * @export
 * @interface IPushProvisionResponse
 */
export interface IPushProvisionResponse {
    /**
     * 
     * @type {IHeader}
     * @memberof IPushProvisionResponse
     */
    common?: IHeader;
    /**
     * "Echoed from request."
     * @type {string}
     * @memberof IPushProvisionResponse
     */
    correlation_id: string;
    /**
     * success or Failure Code. 0000 - Success 1002 - Invalid PAN 1003 - Ineligible BIN 1004 - Ineligible Device Wallets 1005 - PAN ineligible for Device Wallet 1006 - PAN ineligible for Merchants 1007 - Invalid passthruFromIdiSdk 1008 - Invalid Apple Wallet Certificate 1009 - Field Required 1010 - Issuer Card Art Registration incomplete 1991 - System Error 1993 - Unable to determine provision flow 1994 - PAN Ineligible at TSP 1995 - Unable to prepare encryptedPayload / Unable to prepare registrations / Unable to prepare encryptedPayload 1996 - Unable to create request to TSP / Unable to create request to Samsung / Unable to create request to Google 1997 - Unable to prepare passthruToIdiSdk 1998 - Failure in TSP response / Failure in Samsung response / Failure in Google response 1999 - Error in TSP response
     * @type {string}
     * @memberof IPushProvisionResponse
     */
    status_code: string;
    /**
     * This string has to be passed through by issuer mobile app server to issuer app to IDI SDK
     * @type {string}
     * @memberof IPushProvisionResponse
     */
    passthru_to_idi_sdk?: string | null;
    /**
     * Description of failure. Conditional - required if statusCode is not 0000
     * @type {string}
     * @memberof IPushProvisionResponse
     */
    status_description?: string | null;
}

/**
 * Check if a given object implements the IPushProvisionResponse interface.
 */
export function instanceOfIPushProvisionResponse(value: object): value is IPushProvisionResponse {
    if (!('correlation_id' in value) || value['correlation_id'] === undefined) return false;
    if (!('status_code' in value) || value['status_code'] === undefined) return false;
    return true;
}

export function IPushProvisionResponseFromJSON(json: any): IPushProvisionResponse {
    return IPushProvisionResponseFromJSONTyped(json, false);
}

export function IPushProvisionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPushProvisionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'common': json['common'] == null ? undefined : IHeaderFromJSON(json['common']),
        'correlation_id': json['correlationId'],
        'status_code': json['statusCode'],
        'passthru_to_idi_sdk': json['passthruToIdiSdk'] == null ? undefined : json['passthruToIdiSdk'],
        'status_description': json['statusDescription'] == null ? undefined : json['statusDescription'],
    };
}

export function IPushProvisionResponseToJSON(json: any): IPushProvisionResponse {
    return IPushProvisionResponseToJSONTyped(json, false);
}

export function IPushProvisionResponseToJSONTyped(value?: IPushProvisionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'common': IHeaderToJSON(value['common']),
        'correlationId': value['correlation_id'],
        'statusCode': value['status_code'],
        'passthruToIdiSdk': value['passthru_to_idi_sdk'],
        'statusDescription': value['status_description'],
    };
}

